import {Reducer} from "react";

export interface User {
    userName: string;
    name: string;
    lastName: string;
}

export interface AuthorizationState {
    user: User | null;
    isLoggedIn: boolean;
    loading: boolean;
}

export enum AuthorizationActionTypes {
    SET_USER,
    SET_IS_LOGGED_IN,
    SET_IS_LOADING
}

interface SetIsLoggedIn {
    type: AuthorizationActionTypes.SET_IS_LOGGED_IN,
    value: boolean;
}

interface SetIsLoading {
    type: AuthorizationActionTypes.SET_IS_LOADING,
    value: boolean;
}

interface SetUser {
    type: AuthorizationActionTypes.SET_USER,
    value: User;
}

export type AuthorizationAction = SetIsLoggedIn | SetIsLoading | SetUser;

export const AuthorizationReducer: Reducer<AuthorizationState, AuthorizationAction> = (state, action): AuthorizationState => {

    switch (action.type) {
        case AuthorizationActionTypes.SET_IS_LOGGED_IN:
            return {
                ...state,
                isLoggedIn: action.value
            }
        case AuthorizationActionTypes.SET_IS_LOADING:
            return {
                ...state,
                loading: action.value
            }
        case AuthorizationActionTypes.SET_USER:
            return {
                ...state,
                user: action.value
            }
        default:
            return {
                ...state
            }
    }

}